import { createRatesService } from './rate.service';

const ENDPOINT = '/api/national_insurance_rates';
const EnhancementRateService = createRatesService(ENDPOINT, 'national_insurance_rate');

export default EnhancementRateService;